import $ from 'jquery';
import Macy from 'macy';

function masonry(el) {
    const columnsMobile = $(el).data('columns-mobile');
    const columnsPad = $(el).data('columns-pad');
    const columnsDesktop = $(el).data('columns-desktop');
    const marginX = $(el).data('margin-x');
    const marginY = $(el).data('margin-y');

    const macy = Macy({
        container: el,
        trueOrder: false,
        mobileFirst: true,
        waitForImages: true,
        margin: {
            x: marginX,
            y: marginY,
        },
        columns: columnsMobile,
        breakAt: {
            768: columnsPad,
            1260: columnsDesktop,
        }
    });
}

export default masonry;
